import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      school_faculty: '',
      summary: '',
      profile_img: require('@/assets/image/user_default.png'),
      role: ''
    },
    // api_url: process.env.NODE_ENV === 'production' ? 'http://123.255.64.71:8180/fabulearn/instance/api/' : 'http://localhost/fabulearn_jc/api/'
    // api_url: 'http://localhost/fabulearn_jc/api/'
    // api_url: 'https://dev-test.fabulearn.net/jc-api/'
    // api_url: 'http://123.255.64.71:8180/fabulearn/instance/api/'
    api_url: 'http://dummy.fabulearn.net/api/'
  },
  mutations: {
    setUser (state, user) {
      Object.assign(state.user, Object.entries(user).filter(([_, v]) => {
        return v != null && v.length > 0
      }).reduce((acc, [v, k]) => {
        acc[v] = k
        return acc
      }, {}))
      Object.assign(state.user, {
        // id: user.id,
        name: user.first_name + ' ' + user.last_name,
        // exp: 150,
        // level: '學徙',
        // role: user.role,
        profileIcon: user.profile_img
      })
    }
  },
  actions: {
    request (context, { route, method, data }) {
      // return new Promise(resolve => resolve({
      //   data: ''
      // }))
      method = method || 'get'
      let url = context.state.api_url + route
      // console.log(method)
      // console.log(data)
      let option = {
        method: method,
        credentials: 'include'
      }
      if (method === 'get') {
        if (data !== null) {
          let query = ''
          if (data instanceof FormData) {
            console.log(Array.from(data.entries()))
            console.log(Array.from(data.entries()).map(param => param.join('=')))
            query = Array.from(data.entries()).map(param => param.join('=')).join('&')
          } else if (typeof data === 'string') {
            query = data
          }
          if (query.length > 0) {
            url = url + '?' + query
          }
        }
      } else {
        option.body = data
      }
      return fetch(url, option).then(r => {
        // console.log(r)
        if (r.status === 401) {

        }
        return r.json().then(r => {
          if (!r.success) {
            console.log(r)
            throw Error(r.error)
          } else {
            return r.data
          }
        })
      })
    },
    login (context, fd) {
      return context.dispatch('request', {
        route: 'login',
        method: 'post',
        data: fd
      }).then(() => context.dispatch('getProfile'))
    },
    getProfile (context) {
      return context.dispatch('request', {
        route: 'profile'
      }).then(user => {
        context.commit('setUser', user)
        return user
      })
    }
  },
  getters: {
    isLoggedIn: state => Object.values(state.user).length !== 0,
    user: state => state.user,
    role: state => state.user.role,
    isTeacher: state => state.user.role === 'teacher',
    isStudent: state => state.user.role === 'student',
    api_url: state => state.api_url
  }
})
